/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ServerTimeSyncIntervalSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('SERVER_TIME_SYNC_INTERVAL')],
    ['value', /* #__PURE__ */ parsers.maybeNull(parsers.duration)],
]);
export class ServerTimeSyncIntervalSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ServerTimeSyncIntervalSettingParser.decode(input).map(res => new ServerTimeSyncIntervalSetting(res));
    }
    static unsafeDecode(input) {
        return ServerTimeSyncIntervalSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ServerTimeSyncIntervalSettingParser.encode(data);
    }
    static schema() {
        return ServerTimeSyncIntervalSettingParser.schema();
    }
}
